import { Button, Modal, Row, Table } from 'antd';

import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { useCapturePostHog } from '../../../../hooks/useCapturePostHog';
import type { SortedInfo } from '../../../../models/table';
import type { Intervention } from '../programDashboardSlice';
import { GetInterventionsModalProps } from './interventions-modal-props';
import type { DashboardModalType } from './modalDashboardSlice';
import { clearModalFilter, closeDashboardModal, DASHBOARD_MODAL, handleModalTableChange } from './modalDashboardSlice';

export const InterventionsModal = ({ data, filtersInfo }: { data: Intervention[]; filtersInfo: string }) => {
  const dispatch = useAppDispatch();
  const { capturePostHogCustomEvent } = useCapturePostHog();
  const open = useAppSelector((state) => state.modalDashboardSlice.modal === DASHBOARD_MODAL.INTERVENTIONS);
  const { columns, clearSearch } = GetInterventionsModalProps();

  return (
    <Modal
      className="dashboardModal"
      width={'70%'}
      title="Intervention details"
      open={open}
      onCancel={() => {
        capturePostHogCustomEvent('InterventionsModal close modal');
        dispatch(closeDashboardModal());
      }}
      mask={{ blur: false, closable: false }}
      footer={null}
    >
      <Row className="filtersInfoRow" justify="space-between" align="middle">
        <p style={{ marginTop: 'auto', marginBottom: 'auto' }}>{filtersInfo}</p>
        <Button
          onClick={() => {
            dispatch(clearModalFilter());
            clearSearch();
            dispatch(
              handleModalTableChange({
                sorter: {
                  columnKey: 'date',
                  field: 'date',
                  order: 'descend',
                },
              }),
            );
            capturePostHogCustomEvent('InterventionsModal clear filters');
          }}
        >
          Clear filters
        </Button>
      </Row>
      <Table
        rowKey="intervention_id"
        className="dashboardTable"
        columns={columns}
        onChange={(pagination, filters, sorter) => {
          dispatch(handleModalTableChange({ pagination, filters, sorter: sorter as SortedInfo<DashboardModalType> }));
          capturePostHogCustomEvent('InterventionsModal table change');
        }}
        pagination={
          data.length > 20
            ? {
                showTotal: (total, range) => {
                  return `Showing ${range[0]}-${range[1]} of ${total} results`;
                },
                placement: ['bottomEnd'],
                defaultPageSize: 20,
              }
            : false
        }
        dataSource={data}
        scroll={{ y: 'calc(100vh - 400px)' }}
      />
    </Modal>
  );
};
